import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Mail, MapPin, Phone, Globe } from 'lucide-react';

function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Kontakt CasinoGuide.dk - Jonas Schütt Nielsen</title>
        <meta 
          name="description" 
          content="Kontakt CasinoGuide.dk for spørgsmål om udenlandske casinoer, hurtige udbetalinger og Trustly. Få professionel rådgivning om online casino Danmark." 
        />
        <meta name="keywords" content="kontakt casinoguide, casino rådgivning, jonas schütt nielsen, casino ekspert danmark" />
        <link rel="canonical" href="https://casinoguide.dk/kontakt" />
      </Helmet>

      <div className="min-h-screen">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="relative mb-12">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/20 via-blue-500/20 to-cyan-600/20 blur-3xl -z-10"></div>
            <h1 className="text-4xl sm:text-5xl font-bold mb-6 leading-tight">
              <span className="bg-gradient-to-r from-cyan-300 via-blue-300 to-cyan-400 bg-clip-text text-transparent">
                Kontakt
              </span>
              <br />
              <span className="text-blue-100">CasinoGuide.dk</span>
            </h1>
            <p className="text-lg text-blue-200 leading-relaxed">
              Har du spørgsmål om udenlandske casinoer, hurtige udbetalinger eller Trustly? Jeg hjælper gerne med professionel rådgivning om online casino i Danmark.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Info */}
            <div className="space-y-6">
              <div className="bg-slate-800/50 rounded-2xl p-8 border border-cyan-600/20">
                <h2 className="text-2xl font-bold mb-6 bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent">
                  Jonas Schütt Nielsen
                </h2>
                <p className="text-blue-200 mb-6">
                  Full-stack udvikler og casino-ekspert med specialisering i danske og udenlandske spillemarkedet. Jeg hjælper danske spillere med at finde de bedste casinoer med hurtige udbetalinger og sikre betalingsmetoder.
                </p>

                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center">
                      <Mail className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-blue-300">Email</p>
                      <a 
                        href="mailto:jonassnk11@gmail.com" 
                        className="text-cyan-400 hover:text-cyan-300 transition-colors"
                      >
                        jonassnk11@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center">
                      <Phone className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-blue-300">Telefon (Makedonien)</p>
                      <a 
                        href="tel:+38975433740" 
                        className="text-green-400 hover:text-green-300 transition-colors"
                      >
                        +389 75 433 740
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                      <MapPin className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-blue-300">Lokation</p>
                      <p className="text-purple-400">Skopje, Nord Makedonien</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center">
                      <Globe className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <p className="text-sm text-blue-300">GitHub</p>
                      <a 
                        href="https://github.com/jsnk11" 
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-400 hover:text-blue-300 transition-colors"
                      >
                        github.com/jsnk11
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Expertise */}
              <div className="bg-slate-800/50 rounded-2xl p-8 border border-blue-600/20">
                <h3 className="text-xl font-bold mb-4 text-cyan-300">Mine Specialer</h3>
                <div className="space-y-3 text-sm">
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-cyan-400"></span>
                    <span className="text-blue-200">Udenlandske casinoer og licensering</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-green-400"></span>
                    <span className="text-blue-200">Hurtige udbetalingsmetoder (Trustly, krypto, e-wallets)</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-purple-400"></span>
                    <span className="text-blue-200">Casino sikkerhed og verifikationsprocesser</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-yellow-400"></span>
                    <span className="text-blue-200">Danmarks spillelovgivning og skatteforhold</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-blue-400"></span>
                    <span className="text-blue-200">Web development og casino affiliate marketing</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-slate-800/50 rounded-2xl p-8 border border-slate-700/30">
              <h2 className="text-2xl font-bold mb-6 text-blue-100">Send en Besked</h2>
              <form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-blue-300 mb-2">
                    Navn
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-lg focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 text-blue-100 placeholder-blue-400/60"
                    placeholder="Dit navn"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-blue-300 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-lg focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 text-blue-100 placeholder-blue-400/60"
                    placeholder="din@email.dk"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-blue-300 mb-2">
                    Emne
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-lg focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 text-blue-100"
                    required
                  >
                    <option value="">Vælg emne</option>
                    <option value="casino-anbefaling">Casino anbefaling</option>
                    <option value="trustly-spørgsmål">Trustly spørgsmål</option>
                    <option value="udbetaling-problemer">Udbetalingsproblemer</option>
                    <option value="sikkerhed-licens">Sikkerhed og licens</option>
                    <option value="skat-lovgivning">Skat og lovgivning</option>
                    <option value="andet">Andet</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-blue-300 mb-2">
                    Besked
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={6}
                    className="w-full px-4 py-3 bg-slate-900/50 border border-slate-600 rounded-lg focus:border-cyan-400 focus:ring-1 focus:ring-cyan-400 text-blue-100 placeholder-blue-400/60 resize-none"
                    placeholder="Beskriv dit spørgsmål eller hvad du har brug for hjælp til..."
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-gradient-to-r from-cyan-600 to-blue-600 text-white font-bold rounded-lg hover:from-cyan-500 hover:to-blue-500 transition-all duration-200"
                >
                  Send Besked
                </button>
              </form>

              <div className="mt-6 p-4 bg-blue-900/20 border border-blue-500/30 rounded-lg">
                <p className="text-blue-200 text-xs">
                  <strong>Svartid:</strong> Jeg bestræber mig på at svare inden for 24 timer på hverdage. 
                  For hurtige spørgsmål kan du også kontakte mig direkte via email eller telefon.
                </p>
              </div>
            </div>
          </div>

          {/* Professional Background */}
          <div className="mt-12 bg-slate-800/50 rounded-2xl p-8 border border-slate-700/30">
            <h2 className="text-2xl font-bold mb-6 bg-gradient-to-r from-cyan-300 to-blue-300 bg-clip-text text-transparent">
              Professionel Baggrund
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-bold text-blue-100 mb-3">Uddannelse & Erfaring</h3>
                <div className="space-y-3 text-blue-200 text-sm">
                  <p>• Full Stack Development - QinShift Academy/Seavus Academy (2023-2024)</p>
                  <p>• Tidligere Process Operator - Thermo Fisher Scientific</p>
                  <p>• Udvikler hos Innohub - Pazarluk.mk e-commerce platform</p>
                  <p>• Aktiv freelancer på Upwork med fokus på danske projekter</p>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-bold text-blue-100 mb-3">Teknisk Ekspertise</h3>
                <div className="space-y-3 text-blue-200 text-sm">
                  <p>• <strong>Frontend:</strong> React, Angular, TypeScript, JavaScript</p>
                  <p>• <strong>Backend:</strong> C#, Python, Node.js, FastAPI</p>
                  <p>• <strong>Database:</strong> PostgreSQL, AI/ML med TensorFlow</p>
                  <p>• <strong>DevOps:</strong> Docker/Podman, Hetzner server infrastructure</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactPage;